// Où mène une notification. Celles dont l'écran n'avait pas d'adresse partent de la base avec « #/ » : la carte « Avis
// demandé », les salles et le thème du mois (accueil du coach), la séance annulée, la marraine et ses encouragements, le
// surclassement d'un enfant. L'app lit leur clé (dedup_key, qui nomme la séance, la date, le binôme…) pour ouvrir le bon
// écran, et la casquette qui montre la carte (D-072 : une coach qui joue aussi lit sa cloche en casquette Joueuse ; D-103 :
// les notifications de l'enfant chez le parent). Rien n'est réécrit en base : les notifications déjà reçues en profitent.

export interface NotifLike { kind: string; url: string | null; dedup_key?: string | null; about_person?: string | null }
/** L'écran, et la casquette qui le montre quand ce n'est pas la casquette affichée (« coach » : l'accueil du coach). */
export interface NotifGo { hash: string; hat?: 'coach'; home?: boolean }

/** `self` : ma fiche (null sans fiche) ; `on` : le module est-il activé (D-122) ? */
export function notifLink(n: NotifLike, o: { self: string | null; on: (module: 'parrainage') => boolean }): NotifGo | null {
  if (n.url && n.url !== '#/') return { hash: n.url };
  const key = n.dedup_key ?? '';
  const [kind, a, b] = key.split(':');
  // D-148 : « Tout va bien ? » et le rappel de la semaine : leur carte est sur l'accueil (de la joueuse, du parent).
  if (kind === 'checkin' || kind === 'abweek') return { hash: '#/', home: true };
  // Les cartes de l'accueil du coach : l'avis sur un surclassement (D-093), les salles (D-130), le thème du mois.
  if (kind === 'surc-avis' || kind === 'theme' || kind?.startsWith('hall-')) return { hash: '#/', hat: 'coach' };
  // La séance annulée : sa fiche, ce jour-là (« cancel:<séance>:<date>:… »).
  if (kind === 'cancel' && a && /^\d{4}-\d{2}-\d{2}$/.test(b ?? '')) return { hash: `#/e/${a}/${b}` };
  // Une série de séances créée, la composition de la saison : le planning.
  if (kind === 'created' || kind === 'compo') return { hash: '#/planning' };
  // La marraine, ses encouragements : le parrainage des jeunes (D-067), s'il est activé.
  if ((kind === 'mentee' || kind === 'cheerp') && o.on('parrainage')) return { hash: '#/marrainage' };
  // Le surclassement d'un enfant : sa carte dans Mes enfants (le parent) ; le sien, rien de plus que l'accueil.
  if ((kind === 'surc' || kind === 'surc-dec') && n.about_person && n.about_person !== o.self) return { hash: '#/enfants' };
  return null;
}
